import { render } from "./SilimedView.vue?vue&type=template&id=72b16df5&scoped=true"
import script from "./SilimedView.vue?vue&type=script&lang=js"
export * from "./SilimedView.vue?vue&type=script&lang=js"

import "./SilimedView.vue?vue&type=style&index=0&id=72b16df5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b16df5"]])

export default __exports__